import {
    TASK_VEHICLE_AUDIT_LIST,
    TASK_VEHICLE_AUDIT_LIST_SUCCESS,
    TASK_VEHICLE_AUDIT_LIST_ERROR,
    TASK_VEHICLE_AUDIT_MODAL_SET
} from '../../actions';

const INIT_STATE = {
    loading: false,
    error: false,
    modal: false,
    list: { data: [] }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case TASK_VEHICLE_AUDIT_LIST:
            return { ...state, loading: true, error: false };
        case TASK_VEHICLE_AUDIT_LIST_SUCCESS:
            return { ...state, loading: false, list: { data: action.payload } };
        case TASK_VEHICLE_AUDIT_LIST_ERROR:
            return { ...state, loading: false, error: true };
        case TASK_VEHICLE_AUDIT_MODAL_SET:
            return { ...state, modal: action.payload };
        default:
            return state;
    }
};
